import React, { useState, useReducer } from 'react';
import handler from "./handler"

const Context = React.createContext();

const initialState = {
  type: "",
  placementID: "",
  employeeID: "",
  timesheetEmployeeID: "",
  timesheetID: "",
  clientId: "",
  OTtime: [],
  standardTime: [],
  isCalendarLoaded: false,
  loadEntryTable: false,
  isSettingsLoaded: false,
  isPlacementsLoaded: false,
  dateRanges: [],
  selectedRange: [],
  cycles: [],
  isDocumentUploading: false,
  timesheetInfo: {
    startDate: "",
    endDate: "",
    attachmentDetails: [
  ],
  },
  timesheetSettings: {},
  placements: {},
  isSubmitting: false,
  isAlreadySubmitted: false,
  viewingTimesheet: {},
  statusReport:""
}

const ContextProvider = (props) => {
  const [state, handle] = useReducer(handler, initialState);
  return (
    <Context.Provider value={[state, handle]}>
      {props.children}
    </Context.Provider>
  );
}

export { Context, ContextProvider, initialState };